<template>
  <div>
    <Header title="隐私条款" />
    <div class="contianer">
      <div v-html="list" class="product_text"></div>

    </div>
  </div>
</template>

<script>

import Header from '@/components/header'
import wxAppApi from '@/api/wx-app'
export default {
  components: {
    Header
  },
  data () {
    return {
      list: '',
      id: ''
    }
  },
  created () {
    this.id = this.$route.params.id
    console.log(this.$route)
    this.policyInfo()
  },
  methods: {

    policyInfo () {
      var that = this
      var params = {
        id: this.id
      }
      wxAppApi.policyInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          var ruleMsg = res.data.resultData.privacyPolicyInfo.content
          that.list = ruleMsg
        }
      })
    }
  }

}
</script>

<style scoped>
.product_text {
  width: 100%;
}

.product_text>>>img,
.product_text>>>image {
  width: 100%;
  height: auto;
}

.product_text>>>p {
  width: 100%;
  height: auto;
}
.contianer {
  width: calc(100vw - 16px);
  margin: 50px 8px 0 8px;
}

p,
li {
  font-size: 14px;
  line-height: 18px;
}

ul,
li,
dl,
dt,
dd,
ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

.size1 {
  font-size: 25px;
  line-height: 30px;
}

.size2 {
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
}

.size3 {
  font-size: 18px;
  line-height: 30px;
  font-weight: 600;
}</style>
